import { render, staticRenderFns } from "./Questionaire.vue?vue&type=template&id=60cff593&scoped=true&"
import script from "./Questionaire.vue?vue&type=script&lang=js&"
export * from "./Questionaire.vue?vue&type=script&lang=js&"
import style0 from "./Questionaire.vue?vue&type=style&index=0&id=60cff593&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cff593",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VTextarea})
